import { render, staticRenderFns } from "./Landline.vue?vue&type=template&id=5e6a26e3&scoped=true&"
import script from "./Landline.vue?vue&type=script&lang=js&"
export * from "./Landline.vue?vue&type=script&lang=js&"
import style0 from "./Landline.vue?vue&type=style&index=0&id=5e6a26e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6a26e3",
  null
  
)

export default component.exports